import styled from 'styled-components/native';
import {RFValue} from 'react-native-responsive-fontsize';
import FastImage from '../../components/Interface/Images/FastImageWithFallback';
import {Dimensions} from 'react-native';

export const Container = styled.View`
  flex: 1;
  background-color: ${({theme}) => theme.colors.background};
`;

export const BannersContainer = styled.View`
  margin-top: 16px;
  gap: ${RFValue(12)}px;
  padding-bottom: ${RFValue(20)}px;
`;

export const Row = styled.View`
  flex-direction: row;
  padding: 0 24px;
  width: 100%;
  justify-content: space-between;
`;

export const BannerItem = styled.TouchableOpacity`
  width: 100%;
  border-radius: ${RFValue(8)}px;
  overflow: hidden;
`;

export const BannerLabel = styled.View`
  position: absolute;
  top: 0;
  bottom: 0;
  left: ${RFValue(12)}px;
  justify-content: center;
  z-index: 2;
`;

export const BannerTitle = styled.Text`
  color: ${({theme}) => theme.colors.shape};
  font-size: ${RFValue(12)}px;
  font-family: ${({theme}) => theme.fonts.bold};
`;

const bannerWidth = Dimensions.get('window').width - RFValue(48);
const bannerAspectRatio = 1974 / 381;
const bannerHeight = Math.round(bannerWidth / bannerAspectRatio);

// @ts-ignore
export const BannerImage = styled(FastImage)`
  width: 100%;
  height: ${bannerHeight}px;
`;
